import React from 'react';
import { Col, Container, Row, Pagination } from 'react-bootstrap';

export default function Paginationn() {

  let active = 1;
    let items:any = [];
    for (let number = 1; number <= 5; number++) {
      items.push(
        <Pagination.Item key={number} active={number === active}>
          {number}
        </Pagination.Item>
      );
    }

  return (
    <>
      <Container>
        <Row>
          <Col>
            <div className='d-flex justify-content-center'>
              <Pagination size="sm" className='border-none bg-muted'>
                  {items}
                  <Pagination.Ellipsis />
                  <Pagination.Item>{20}</Pagination.Item>
                  </Pagination>
             </div>
          </Col>
        </Row>
      </Container>
    </>
  )
}
